export default "__VITE_ASSET__67411f47__"